import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Header.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { HOME_PAGE } from '../../constants/routes';
import BreadCrumbsComponent from 'componentsV2/Breadcrumbs/BreadCrumbsComponent';
import { buildBreadCrumbDataNew } from 'utils/utils';
import Search from 'componentsV2/Search/Search';
import { searchActions } from 'actions/search';
import {
  advancedSearchPayloadType,
  simpleSearchPayloadType
} from 'type/homeType';

const Header: React.FC<{ searchRef: React.RefObject<HTMLCoreSearchElement> }> = ({ searchRef }) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const searchKeyword = useSelector((state: any) => state.getSearchValues.keyword);
  const isSearch = searchKeyword?.length > 0;

  const navigate = useNavigate();
  const location = useLocation();
  const { userName } = useSelector(
    (state: any) => state?.userTypeReducer?.userType?.data || { userName: '' }
  );

  const [keyword, setKeyword] = useState('');
  const paginationValues = useSelector(
    (state: any) => state.getSearchValues.pagination
  );

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!(e.target as HTMLInputElement)?.value) {
      e.preventDefault();
      // handleOnClearSearch();
    }
  };

  const keywordHandler = (event: any) => {
    setKeyword(event.trim());
    // dispatch(searchActions.getSearchValues(event.trim(),paginationValues));
    if (event.trim().length < 1) {
      dispatch(searchActions.getSearchValues(event.trim(), paginationValues));
      fetchRecentUploads(1, 10);
    }
  };

  const fetchRecentUploads = useCallback(
    async (pageNumber: number, pageSize: number) => {
      const payload: advancedSearchPayloadType = {
        userId: userName,
        pageNumber,
        pageSize
      };
      dispatch(searchActions.advancedSearch(payload));
    },
    [dispatch, userName]
  );

  useEffect(() => {
    if (searchRef?.current?.clearSearchText && !location.pathname.includes('home')) {
      dispatch(searchActions.getSearchValues(''));
      searchRef.current.clearSearchText();
    }
  }, [location.pathname]);

  const handleOnClearSearch = () => {
    dispatch(searchActions.getSearchValues(''));
    fetchRecentUploads(1, 10);
    setKeyword('');
  };

  const searchHandler = () => {
    const payload: simpleSearchPayloadType = {
      keyword: keyword,
      pageNumber: 1,
      pageSize: 10
    };
    dispatch(searchActions.simpleSearch(payload));
    dispatch(
      searchActions.getSearchValues(keyword, { pageNumber: 1, pageSize: 10 })
    );
    const isHome = location.pathname.includes('home');
    if (!isHome) {
      navigate(HOME_PAGE);
    }
  };

  return (
    <div className="headerv2">
      <div className="header-main-v2">
        <div className="breadcrumbs-container">
          <BreadCrumbsComponent
            breadCrumbData={buildBreadCrumbDataNew(location?.pathname, isSearch)}
          />
        </div>
        <>
          <div className="search-bar">
            <Search
              searchHandler={searchHandler}
              handleKeyUp={handleKeyUp}
              keywordHandler={keywordHandler}
              handleOnClearSearch={handleOnClearSearch}
              searchRef={searchRef}
            />
          </div>
        </>
      </div>
    </div>
  );
};


export default Header;